<script setup lang="ts">
import type { IconFonts } from "@/types";

interface Props {
    label: string;
    value?: string | number;
    iconFont?: IconFonts;
    trailingIcon?: string;
    active?: null | boolean;
}

const props = withDefaults(defineProps<Props>(), {
    iconFont: "ms",
    active: null,
});
</script>

<template>
    <span
        class="mdc-evolution-chip"
        :class="{
            'mdc-evolution-chip-active': props.active !== null && props.active,
        }"
        role="row"
    >
        <span
            class="mdc-evolution-chip__cell mdc-evolution-chip__cell--primary"
            role="gridcell"
        >
            <button
                class="mdc-evolution-chip__action mdc-evolution-chip__action--primary"
                type="button"
            >
                <span
                    class="mdc-evolution-chip__text-label"
                    v-html="props.label"
                />
                <i
                    class="icon mdc-evolution-chip__icon--trailing icon-close ms-icon-close"
                    v-if="props.active !== null && props.active"
                    v-text="'close'"
                />
                <i
                    v-if="props.trailingIcon && props.iconFont === 'ms'"
                    class="material-symbols-outlined mdc-evolution-chip__icon--trailing"
                    :class="'ms-icon-' + props.trailingIcon"
                    v-text="props.trailingIcon"
                />
                <i
                    v-if="props.trailingIcon && props.iconFont !== 'ms'"
                    class="mdc-evolution-chip__icon--trailing"
                    :class="props.iconFont + ' ' + props.trailingIcon"
                    v-text="props.trailingIcon"
                />
            </button>
        </span>
    </span>
</template>

<style scoped lang="scss">
@use "@/scss/design-library/colors";
.mdc-evolution-chip-active {
    background-color: #{colors.$light-grey};
    border: 2px solid transparent;
}
.mdc-evolution-chip {
    margin: 0;
}
.ms-icon-close {
    width: 25px;
    height: 25px;
    font-size: 25px;
}
</style>
